/**
 * Formatador de valor monetário. `formatBRL` é o nome histórico; aceita qualquer
 * moeda. Implementação compartilhada em @trakd/notifications/money (client-safe).
 */
import { currencySymbol, formatMoney } from '@trakd/notifications/money';

export function formatBRL(value: number, currency = 'BRL'): string {
  return formatMoney(value, currency);
}

export { formatMoney, currencySymbol };
